import { BalanceType } from './balance.constants';
import { pendingRequestsTypes } from './requests.constants';
export interface IPendingRequest {
	balancesRequests: IPendingRequestAnalytics;
	bankAccountsRequests: IPendingRequestAnalytics;
	beneficiariesRequests: IPendingRequestAnalytics;
	generalRequests: IPendingRequestAnalytics;
	paymentRequests: IPendingRequestAnalytics;
	withdrawalRequests: IPendingRequestAnalytics;
}

export const mapingFeature = {
	[pendingRequestsTypes.BENEFICIARIES]: 'beneficiary',
	[pendingRequestsTypes.BALANCES]: 'balanceActivity',
	[pendingRequestsTypes.BALANCES_BO_REQUESTS]: 'balanceActivity',
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: 'supportRequest',
	[pendingRequestsTypes.GENERAL_SUPPORT]: 'supportRequest',
	[pendingRequestsTypes.WITHDRAWAL_BO_APPROVED]: 'supportRequest',
	[pendingRequestsTypes.PAYMENTS]: 'payment',
	[pendingRequestsTypes.CONTACTS]: 'contactRequest',
	[pendingRequestsTypes.BANK_ACCOUNTS]: 'bankAccount',
};
export const additionalMappingFeature: any = {
	[pendingRequestsTypes.BALANCES]: 'companyBankAccounts',
	[pendingRequestsTypes.BENEFICIARIES]: 'allowedPaymentCategoryIds',
};

export const mapingFeatureToEndpoint = {
	[pendingRequestsTypes.BENEFICIARIES]: 'beneficiary',
	[pendingRequestsTypes.BALANCES]: 'balance',
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: 'withdrawal',
	[pendingRequestsTypes.WITHDRAWAL_BO_APPROVED]: 'withdrawal',
	[pendingRequestsTypes.GENERAL_SUPPORT]: 'support_request',
	[pendingRequestsTypes.PAYMENTS]: 'payment',
	[pendingRequestsTypes.CONTACTS]: 'account',
	[pendingRequestsTypes.BANK_ACCOUNTS]: 'bank_account',
	[pendingRequestsTypes.BALANCES_BO_REQUESTS]: 'balance',
};

export const permissionsForProfile = {
	[pendingRequestsTypes.BENEFICIARIES]: ['approve_beneficiary'],
	[pendingRequestsTypes.BALANCES]: ['bo_signer_main', 'bo_signer_secondary'],
	[pendingRequestsTypes.BALANCES_BO_REQUESTS]: [],
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: ['approve_withdrawal'],
	[pendingRequestsTypes.WITHDRAWAL_BO_APPROVED]: ['approve_withdrawal'],
	[pendingRequestsTypes.GENERAL_SUPPORT]: ['approve_support_request'],
	[pendingRequestsTypes.PAYMENTS]: ['approve_payment'],
	[pendingRequestsTypes.CONTACTS]: ['approve_account'],
	[pendingRequestsTypes.RESEND_WELCOME_EMAIL]: ['resend_welcome_email'],
	[pendingRequestsTypes.BANK_ACCOUNTS]: ['approve_bank_account'],
};

export const mappingTypeForProfile = {
	[pendingRequestsTypes.BALANCES_BO_REQUESTS]: pendingRequestsTypes.BALANCES,
};

export const mappingTypeForActionProfile = {
	[BalanceType.Withdrawal]: BalanceType.Withdrawal,
};

export interface IPendingRequestAnalytics {
	total: number;
	today: number;
}

export enum SupportStatus {
	Pending = 'Pending',
	Completed = 'Completed',
	Rejected = 'Rejected',
	InProgress = 'InProgress',
}

/** Max height (px) for duplicate deposit list scroll area; enables scroll when >2 items */
export const DUPLICATE_POPUP_MAX_HEIGHT = 280;

/** MUI palette key for duplicate deposit box background */
export const DUPLICATE_DEPOSIT_BOX_BG = 'grey.100';

/** MUI palette key for duplicate deposit box background on hover */
export const DUPLICATE_DEPOSIT_BOX_BG_HOVER = 'grey.200';

/** Pastel colors for duplicate balance-addition row highlighting (manual vs digital cross-check) */
export const DUPLICATE_ROW_COLORS = [
	'#E0F7FA', // light cyan
	'#E8F5E9', // light green
	'#E1F5FE', // light blue
	'#E0F2F1', // light teal
	'#FFE4E1', // misty rose
	'#FFF3E0', // light orange
	'#F3E5F5', // light purple
	'#FFF8E1', // light yellow
	'#FCE4EC', // light pink
	'#EFEBE9', // light grey
];

export interface DuplicateDepositInfo {
	id: number;
	amount: number;
	currencyCode: string;
	currencySymbol: string;
	createdAt: string;
	status: string;
	reference?: string;
}

export interface DuplicateBalanceCheckResult {
	hasDuplicates: boolean;
	digitalBalanceAdditions: DuplicateDepositInfo[];
}
